import { useState } from "react";
import { useDotLegalSnackbar } from "@dotlegal/dotlegal-ui-components";
import { useDotLegalMutation, useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";
import { post } from "@common/api/apiShared";
import { useTranslation } from "@localization/useTranslation";
import { useResponsibleQuery } from "../../../user/hooks/useResponsibleQuery";
import { getTaskMasterDataUrl } from "../masterDataSection/MasterDataSection.hooks";
import { TaskMasterDataViewModel } from "../masterDataSection/MasterDataSection.types";
import { SendTaskReminderDialogProps } from "./SendTaskReminderDialog";

export function useSendTaskReminderDialog(props: SendTaskReminderDialogProps) {
    const { translateString } = useTranslation();
    const snackbar = useDotLegalSnackbar();
    const [recipientIds, setRecipientIds] = useState<Array<string>>([]);

    const masterDataQuery = useDotLegalQuery<TaskMasterDataViewModel>(getTaskMasterDataUrl(props.taskId));
    const responsibleQuery = useResponsibleQuery();

    const accountableIds = [masterDataQuery.data?.responsible, ...(masterDataQuery.data?.assignees ?? [])];
    const recipientOptions = responsibleQuery.userData?.filter((user) => accountableIds.includes(user.id));

    const sendReminderMutation = useDotLegalMutation(sendReminderApi, {
        onSuccess: () => {
            snackbar.show(translateString("taskReminderSent"));
            props.onCloseDialog();
        },
    });

    return {
        recipientIds,
        recipientOptions,
        isLoading: masterDataQuery.isLoading || responsibleQuery.isLoading,
        isSending: sendReminderMutation.isLoading,
        setRecipientIds,
        onSendClick: () => sendReminderMutation.mutate(),
    };

    function sendReminderApi() {
        return post(`/task/${props.taskId}/send-reminder`, { recipientIds });
    }
}
